<template>
  <div style="padding: 20px;">
    <v-row style="max-width:800px;" no-gutters>
      <v-col
        cols="12"
        sm="6"
        style="padding: 20px;"
      >
        <v-autocomplete
          v-model="oldWorkspace"
          :items="workspaces"
          outlined
          dense
          class="mx-4"
          flat
          hide-no-data
          hide-details
          color="#123123"
          item-text="Name"
          item-value="ID"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        style="padding: 20px;"
      >
        <v-autocomplete
          v-model="newWorkspace"
          :items="workspaces"
          outlined
          dense
          class="mx-4"
          flat
          hide-no-data
          hide-details
          color="#123123"
          item-text="Name"
          item-value="ID"
        />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        style="padding: 20px;background-color: orange;"
      >
        <v-btn 
          @click="handleMigrate"
          block
          color="red"
        >
          Migrar
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        sm="12"
      >
        <v-row style="width:100%;" no-gutters
          v-for="(oldMenu, index) of oldMenus"
          :key="oldMenu.ID"
          :style="{ 'background-color' : index % 2 === 0 ? 'grey' : '#CCCCCC' }"
        >
          <v-col
            cols="12"
            sm="6"
            style="padding: 20px;"
          >
            {{index}} - {{ index % 2 }}
            {{oldMenu.Name}}
          </v-col>
          <v-col
            cols="12"
            sm="6"
            style="padding-top: 10px;"
          >
            <v-autocomplete
              v-show="newMenus.length > 0"
              v-model="oldMenu.NewID"
              :items="newMenus"
              outlined
              dense
              class="mx-4"
              flat
              hide-no-data
              hide-details
              color="#123123"
              item-text="Name"
              item-value="ID"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import axios from 'axios'
import api from '@/services/api'
import utils from '@/services/utils'
export default {
  data: () => ({
    workspaces: [],
    oldWorkspace: null,
    newWorkspace: null,
    oldMenus: [],
    newMenus: [],
  }),
  watch: {
    oldWorkspace () {
      this.handleGetMenus(true)
    },
    newWorkspace () {
      this.handleGetMenus(false)
    },
  },
  mounted () {
    this.handleGetWorkspaces()
  },
  methods: {
    async handleGetWorkspaces () {
        api.getAllWithoutLimit ('dtouch', `v1/internal/users/${utils.getUser()}/workspaces`)
          .then(response => {
            this.workspaces = [{ ID: null, Name: '' }, 
            ...response.sort((a, b) => a.Name.localeCompare(b.Name))
            .map(item => {
              return {
                ID: item.ID,
                Name: item.Name
              }
            })
          ]
          })
    },
    async handleGetMenus (isOld) {
      try {
        const results = []
        const aux = await new Promise((resolve) => api.getAllWithoutLimit ('dtouch', `v1/public/workspaces/${isOld ? this.oldWorkspace : this.newWorkspace}/menus/`, false)
          .then((response) => {
            response = response.filter(x => x.Name).map(item => {
              return {
                ID: item.ID,
                Name: item.Name ? utils.getTranslation(JSON.parse(item.Name), this.locale) : null,
                ORD: item.ORDPrimary,
                ParentID: item.ParentID,
              }
            })
            resolve(response)
          }))
        if (aux && aux.length > 0) {
          for (const m of aux) {
            results.push(m)
            results.push(...await new Promise((resolve) => api.getAllWithoutLimit ('dtouch', `v1/public/menus/${m.ID}/submenus/`, false)
              .then((response) => {
                response = response.filter(x => x.Name).map(item => {
                  return {
                    ID: item.ID,
                    Name: `${m.Name} / ${item.Name ? utils.getTranslation(JSON.parse(item.Name), this.locale) : null}`,
                    ORD: item.ORDPrimary,
                    ParentID: item.ParentID,
                  }
                })
                resolve(response)
              })))
          }
        }

        results.unshift({ ID: 'mainMenu3', Name: 'M.Sup.[ 4 ]'})
        results.unshift({ ID: 'mainMenu2', Name: 'M.Sup.[ 3 ]'})
        results.unshift({ ID: 'mainMenu1', Name: 'M.Sup.[ 2 ]'})
        results.unshift({ ID: 'mainMenu0', Name: 'M.Sup.[ 1 ]'})

        if (isOld) {
          this.oldMenus = results
        } else {
          this.newMenus = results
        }
      } catch (error) {
        console.log(error)
      }
    },
    async handleMigrate () {
      try {
        const body = {
          oldWorkspace: this.oldWorkspace,
          newWorkspace: this.newWorkspace,
          menus: this.oldMenus.filter(x => x.NewID).map(item => {
            return {
              old: item.ID,
              new: item.NewID,
              name: item.Name
            }
          })
        }
        //const baseURL = 'http://localhost:3805'
        const baseURL = 'https://cm-dtouch-stats-api.dtouch.es'

        const aux = await new Promise((resolve, reject) => axios.post(`${baseURL}/v1/public/stats/migrate`, body)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            console.log(error)
            reject(error)
          }))
        console.log(aux)
        alert('Terminado')
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>
